import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'
import { FaExclamationCircle } from 'react-icons/fa'

type AlertSeverity = 'error' | 'warning' | 'success' | 'info'

type Props = ComponentPropsWithoutRef<typeof FaExclamationCircle> & {
  severity: AlertSeverity
}

const SEVERITY_STYLES = {
  error: 'text-red', // エラー・赤字・問題
  warning: 'text-yellow', // 警告・注意
  success: 'text-green', // 成功・手入力・正常
  info: 'text-primary' // 情報・変更履歴・プライマリー
} as const

/**
 * 汎用アラートアイコン
 * severity に応じて色とセマンティクスを変更します
 */
export const AlertIcon: FC<Props> = ({
  className,
  children,
  size = 12,
  severity,
  ...props
}) => {
  return (
    <div
      className={clsx([
        'inline-flex items-center gap-1.5',
        SEVERITY_STYLES[severity],
        className
      ])}
    >
      <FaExclamationCircle {...props} size={size} />
      {children}
    </div>
  )
}
